import { render, staticRenderFns } from "./ReceivablesByTract.vue?vue&type=template&id=726fd39a&"
import script from "./ReceivablesByTract.vue?vue&type=script&lang=js&"
export * from "./ReceivablesByTract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports